import type { ProgramNonPendingUserRsvp } from 'models';
import { Button, CheckCircleFillIcon, CloseCircleFillIcon } from 'ui';
import { useEventRsvpLabels } from '../../../../hooks';

type P = {
  block?: boolean;
  loading: boolean;
  onAction: () => void;
  size: 'large' | 'small';
  variant: ProgramNonPendingUserRsvp;
};

const getVariantIcon = ({ variant }: { variant: ProgramNonPendingUserRsvp }) => {
  switch (variant) {
    case 'going':
      return <CheckCircleFillIcon type="success" />;
    case 'not_going':
      return <CloseCircleFillIcon type="error" />;
  }
};

const EventRsvpButton = ({ block, loading, onAction, size, variant }: P) => {
  const { getButtonActionLabel } = useEventRsvpLabels();

  return (
    <Button
      block={block}
      icon={getVariantIcon({ variant })}
      loading={loading}
      onClick={(event) => {
        event.preventDefault();
        onAction();
      }}
      size={size}
    >
      {getButtonActionLabel({ action: variant })}
    </Button>
  );
};
export default EventRsvpButton;
